import VueFileIcon from './VueFileIcon.vue';
import VueFilePreview from './VueFilePreview.vue';
import VueFileList from './VueFileList.vue';
import VueFileListItem from './VueFileListItem.vue';
import VueFileAgent from './VueFileAgent.vue';

export default {
  VueFileIcon,
  VueFilePreview,
  VueFileList,
  VueFileListItem,
  VueFileAgent,
}
